export * from '@/components';
export * from './prime-vue';
export * from './vee-validate';



// WEBPACK FOOTER //
// ./src/plugins/index.js